
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Variable } from '../forms/formula-tester/formula-tester.component';
import { FormulaLabComponent } from '../forms/formula-lab/formula-lab.component';
import { QueryExecutorComponent } from '../forms/query-executor/query-executor.component';
import { DialogService } from './dialog.service';
import { HTTPService } from './http.service';
import { Subscription } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class FormulaServices {
  subformula: Subscription;
  
  
  constructor(private dialogServices:DialogService, private http:HTTPService) { }

  transformVariable(objeto:Object|UntypedFormGroup, variables:Variable[]){

    if ( variables!= null ){
      if ( objeto instanceof UntypedFormGroup){
        Object.keys(objeto.controls).forEach(control=>{
          const abstractControl = objeto.controls[control];
          let param:Variable = {
            key: control,
            value: String(abstractControl.value),
            type:'TEXTO'
        }
          variables.push(param);
        });

      }else{
        Object.keys(objeto).forEach(key=>{
          if ( objeto[key]!=null && !(objeto[key] instanceof Object ) && !(objeto[key] instanceof Array ) ) {
            
            let param:Variable = {
                key: key,
                value: String(objeto[key]),
                type:'TEXTO'
            }
            variables.push(param);
          }
        });
      }
      
    }
  }

  openFormula(formula:string, variables:Variable[]){
    
    let ob = {ts:false}
    ob['formula'] = formula;
    ob['variables'] = variables;
    return new Promise((resolve,reject)=>{
        this.dialogServices.openGenericDialog(FormulaLabComponent,ob,(f)=>{
          if ( f['formula']){
            resolve(f['formula']);
          }
        },()=>{},'80vh','80vw',false,null,'S','80px');    
    });
  }


  // motorNovo=false (default): motor antigo de producao = zero impacto nas telas atuais.
  // Passe motorNovo=true para a tela usar o MOTOR NOVO isolado (drop-in simples).
  executeFormula(expression:string, variables:Variable[], motorNovo:boolean = false){

    return new Promise((resolve,reject)=>{

      let ob = {
          expressao: expression,
          novo: true,
          motorNovo: motorNovo,
          values: variables
      }
      
      this.subformula = this.http.post(ob,"FormulaServices/test",true,true,false).subscribe(
        {
          next:(x:object)=>{
                resolve(x['resultado']);
          },
          error:(e)=>{
            reject(e);
          },
          complete:()=>{
            this.subformula.unsubscribe();
          }
        });
    });
  }
  
  
  openQuery(query: any, params: Variable[]) {
    let ob = {
        query: query
    }
    
    return new Promise((resolve,reject)=>{
      this.dialogServices.openGenericDialog(QueryExecutorComponent,ob,(f)=>{
        if ( f['query']){
          resolve(f['query']);
        }
      },()=>{},'80vh','80vw',false,null,'S','80px');    
    });
  }

}
